import "isomorphic-fetch";
import { BASE_URL } from "../env.config";

import { setLoggedIn } from "./authService";

const headers = {
  "Content-Type": "application/vnd.api+json",
  Accept: "application/vnd.api+json",
};

export async function refresh() {
  const path = "v1/api/aut/v1/api/auth/refresh";
  const payload = {};

  if (sessionStorage.getItem("access_token")) {
    payload.refresh_token = sessionStorage.getItem("refresh_token");
  }

  const [resp, status] = await request(path, "POST", payload);
  if (status === 200)
    sessionStorage.setItem("access_token", resp?.access_token);
  return [resp, status];
}

export async function request(path, method, payload = null, fullPath) {
  let [resp, status] = await _request(path, method, payload, fullPath);
  if (status >= 401) {
    if (resp.msg === "NOT_AUTHORIZED") {
      return await logout();
    }
    if (resp.msg === "INVALID_TOKEN") {
      await logout();
      return await _request(path, method, payload, fullPath);
    }
    if (resp.msg === "AUTHENTICATION_EXPIRED") {
      await refresh();
      [resp, status] = await _request(path, method, payload, fullPath);
    }
  }
  return [resp, status];
}

export async function logout() {
  sessionStorage.removeItem("access_token");
  sessionStorage.removeItem("refresh_token");
  setLoggedIn(false);
}

async function _request(path, method, payload, fullPath) {
  console.log(`[API REQUEST] ${method} ${path}`);
  let url = BASE_URL + path;
  let tempHeaders = {};
  let requestOptions = {
    method: method,
    credentials: "include",
    headers: {},
  };

  if (fullPath) {
    requestOptions = {
      method: method,
      headers: {},
    };
    url = fullPath;
  }

  if (sessionStorage.getItem("access_token") && !fullPath) {
    tempHeaders.Authorization = `Bearer ${sessionStorage.getItem(
      "access_token"
    )}`;
  }

  if (payload) {
    if (payload instanceof FormData) {
      requestOptions.body = payload;
    } else {
      requestOptions.body = JSON.stringify(payload);
    }
  }

  if (!(payload instanceof FormData)) {
    tempHeaders = {
      ...tempHeaders,
      ...headers,
    };
  }

  requestOptions.headers = tempHeaders;

  const req = await fetch(url, requestOptions);
  console.log(`[API RESPONSE] ${method} ${path} status: ${req.status}`);

  const resp = await req
    .clone()
    .json()
    .catch(() => req.text());
  return [resp, req.status];
}
